import ActiveType from "./ActiveType";
export default ActiveType;
